<div
  class="message-column"
  [ngClass]="{
    'from-system': fromSystem,
    'from-me': fromMe,
    'from-participant': fromSender,
  }"
>
  <div [ngClass]="{ 'first-of-group': isFirstOfGroup }">
    @if (isWelcomeMessage) {
      <div class="welcome">
        {{ message.content }}
      </div>
    }

    @if (isWelcomeMessage2) {
      <div class="welcome smaller-width">
        {{ message.content }}
      </div>
    }

    <!-- System -->
    @if (isSystemMessage) {
      <div
        class="system"
        [ngClass]="{
          'system-patient':
            message.type === 'UidMismatch' ||
            message.type === 'PatientDataChanged',
        }"
      >
        {{ message.content }}
      </div>
    }
    <!-- Standard Message -->
    <div class="relative">
      <div id="{{ 'messageAnchor' + message.id }}" class="message-anchor"></div>
    </div>
    @if (
      isStandardMessage ||
      isImageMessage ||
      isVideoMessage ||
      isPatientFileMessage ||
      isVideoCallMessage ||
      isAudioMessage
    ) {
      <div class="standard-message-container standard-box">
        <div class="standard-message-container-inside">
          @if (isForwarded) {
            <app-message-forwarded-label
              [class.patientFile]="isPatientFileMessage"
            ></app-message-forwarded-label>
          }
          <!-- Text -->
          @if (isStandardMessage) {
            <div class="text-message-container" [class.forwarded]="isForwarded">
              @if (message.replyToMessage && !message.deletedOnUtc) {
                <div class="pre-wrap quote">
                  <app-quoted-message
                    [message]="message.replyToMessage"
                    [fromMe]="fromMe"
                    [fromSender]="fromSender"
                    [userAccount]="userAccount"
                    [participantAccount]="pMap[message.replyToMessage.sentBy]"
                    (findChat)="findChat(message.replyToMessage)"
                    [collapsible]="false"
                  ></app-quoted-message>
                </div>
              }
              <div
                data-testid="message-content"
                (click)="clicked($event)"
                class="pre-wrap my-text"
                [ngClass]="{
                  emoji: message.emoji,
                  deleted: !!message.deletedOnUtc,
                }"
              >
                @for (block of messageLogicalBlocks; track block) {
                  <span>
                    @if (block.type === "mention") {
                      <span
                        class="mentioned-message"
                        (click)="
                          $event.stopPropagation();
                          handleMentionClicked(block.mention)
                        "
                        >{{ block.content }}</span
                      >
                    }
                    @if (block.type === "text") {
                      <span>{{ block.content }}</span>
                    }
                    @if (block.type === "link") {
                      <a
                        class="link"
                        (click)="
                          handleLinkClick($event, block.link);
                          $event.stopPropagation()
                        "
                        target="_blank"
                        [href]="block.link"
                        >{{ block.content }}</a
                      >
                    }
                  </span>
                }
              </div>
            </div>
          }
          <!-- File -->
          @if (isPatientFileMessage) {
            <div>
              <div
                class="patient-file-container celo-cursor-pointer"
                (click)="
                  viewFile(message.metadata.fileId); $event.stopPropagation()
                "
              >
                <div class="icon">
                  <mat-icon>picture_as_pdf</mat-icon>
                </div>
                <div class="info">
                  <div class="name celo-elipsis">
                    {{
                      message.metadata.fileName
                        ? message.metadata.fileName
                        : "No Filename"
                    }}
                  </div>
                  <div class="description celo-elipsis">
                    {{
                      message.metadata.fileDescription
                        ? message.metadata.fileDescription
                        : "No description"
                    }}
                  </div>
                  <div class="action celo-elipsis">Click to open</div>
                </div>
              </div>
            </div>
          }
          <!-- Image -->
          @if (isImageMessage) {
            <div class="img-message" [ngClass]="pic_size">
              <img
                data-testid="message-photo"
                [attr.data-media-id]="messageOriginal.metadata.photoId"
                [src]="
                  '/api/v2/media/' +
                    messageOriginal.metadata.photoId +
                    '?size=Medium&conversationId=' +
                    conversationId +
                    '&messageId=' +
                    message.marker
                    | clink
                    | secure
                "
                (load)="is_image_loaded = true"
                class="appear-m"
                [ngClass]="{ 'appear-now': is_image_loaded }"
                (click)="
                  viewPhoto(messageOriginal.metadata.photoId);
                  $event.stopPropagation()
                "
              />
              @if (
                patientId &&
                message.metadata &&
                message.metadata.uid &&
                message.metadata.uid !== patientId
              ) {
                <div class="mismatch_template">
                  <div class="mismatch_content">
                    <div class="icon">
                      <i class="material-icons">error</i>
                    </div>
                    <div class="text">Patient ID Mismatch</div>
                  </div>
                </div>
              }
            </div>
          }
          <!-- Video (non-call) -->
          @if (isVideoMessage) {
            <div class="img-message" [ngClass]="pic_size">
              <img
                [src]="
                  '/api/v2/media/' +
                    messageOriginal.metadata.photoId +
                    '?size=Medium&conversationId=' +
                    conversationId +
                    '&messageId=' +
                    message.marker
                    | clink
                    | secure
                "
                (load)="is_image_loaded = true"
                class="appear-m"
                [ngClass]="{ 'appear-now': is_image_loaded }"
                (click)="
                  viewVideo(messageOriginal.metadata.photoId);
                  $event.stopPropagation()
                "
              />
              <div class="video_template">
                <div class="video_content">
                  <div class="icon">
                    <i class="material-icons">play_circle</i>
                  </div>
                </div>
              </div>
              @if (
                patientId &&
                message.metadata &&
                message.metadata.uid &&
                message.metadata.uid !== patientId
              ) {
                <div class="mismatch_template">
                  <div class="mismatch_content">
                    <div class="icon">
                      <i class="material-icons">error</i>
                    </div>
                    <div class="text">Patient ID Mismatch</div>
                  </div>
                </div>
              }
            </div>
          }
          <!-- Audio Message -->
          @if (isAudioMessage) {
            <div class="audio-message">
              @if (message.replyToMessage && !message.deletedOnUtc) {
                <div class="pre-wrap quote">
                  <app-quoted-message
                    [message]="message.replyToMessage"
                    [fromMe]="fromMe"
                    [fromSender]="fromSender"
                    [userAccount]="userAccount"
                    [participantAccount]="pMap[message.replyToMessage.sentBy]"
                    (findChat)="findChat(message.replyToMessage)"
                    [collapsible]="false"
                  ></app-quoted-message>
                </div>
              }
              <!-- Note secure pipe is not used as we want to lazy load audio messages -->
              <app-audio-playback-bar
                [mediaUrl]="
                  '/api/v2/media/' +
                  messageOriginal.metadata.photoId +
                  '?conversationId=' +
                  conversationId +
                  '&messageId=' +
                  message.marker
                "
                [duration]="message.metadata.duration"
                [color]="fromMe ? '#fff' : '#8f8e94'"
                [buttonBackgroundColor]="fromMe ? '#80c3fd' : '#b2b2b2'"
              ></app-audio-playback-bar>
            </div>
          }
          @if (isImageMessage || isVideoMessage) {
            <div [ngClass]="pic_size + '_caption'">
              <div class="media-captian">
                <div
                  (click)="clicked($event)"
                  class="pre-wrap my-text"
                  [ngClass]="{ emoji: message.emoji }"
                >
                  @for (block of messageLogicalBlocks; track block) {
                    <span>
                      @if (block.type === "mention") {
                        <span
                          class="mentioned-message"
                          (click)="
                            $event.stopPropagation();
                            handleMentionClicked(block.mention)
                          "
                          >{{ block.content }}</span
                        >
                      }
                      @if (block.type === "text") {
                        <span>{{ block.content }}</span>
                      }
                      @if (block.type === "link") {
                        <a
                          class="link"
                          (click)="
                            handleLinkClick($event, block.content);
                            $event.stopPropagation()
                          "
                          target="_blank"
                          [href]="block.link"
                          >{{ block.content }}</a
                        >
                      }
                    </span>
                  }
                </div>
              </div>
            </div>
          }
          <!-- Video Call -->
          @if (isVideoCallMessage) {
            <div>
              <div
                class="video-call-container"
                [ngClass]="{
                  'celo-cursor-pointer': isVideoCallInProgress,
                  actionable: isVideoCallInProgress,
                }"
                (click)="joinVideoCall($event)"
              >
                <div class="icon">
                  <mat-icon svgIcon="video-on"></mat-icon>
                </div>
                <div class="info">
                  <div class="title celo-elipsis">
                    {{ message.content }}
                  </div>
                  @if (isVideoCallInProgress) {
                    <div class="action celo-elipsis">Click to join</div>
                  }
                  @if (callDurationMessage) {
                    <div class="description celo-elipsis">
                      {{ callDurationMessage }}
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (message.deletedOnUtc) {
            <div class="time-stamp"></div>
          }
          @if (!message.deletedOnUtc) {
            <div
              class="time-stamp"
              [matTooltip]="message.sentOnUtc | dateFormat: 'medium'"
            >
              {{ message.sentOnUtc | dateFormat: "shortTime" }}
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
